import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuestionCategory } from '../models/example-question.model';

@Component({
    selector: 'app-example-questions',
    templateUrl: './example-questions.component.html',
    styleUrls: ['./example-questions.component.scss'],
    standalone: false
})
export class ExampleQuestionsComponent {
    @Input() visible: boolean = true;
    @Output() questionSelected = new EventEmitter<string>();

    public categories: QuestionCategory[] = [
        {
            title: 'EWO Search',
            icon: 'search',
            iconClass: 'search-icon',
            questions: [
                { text: 'Find EWOs related to ammonia piping' },
                { text: 'Search for heat exchanger modifications' },
                { text: 'Similar projects for valve replacement' }
            ]
        },
        {
            title: 'CES Documents',
            icon: 'description',
            iconClass: 'document-icon',
            questions: [
                { text: 'CES requirements for sour service' },
                { text: 'Material selection standards for H2S' },
                { text: 'Corrosion allowance for carbon steel' }
            ]
        },
        {
            title: 'ESRA Database',
            icon: 'storage',
            iconClass: 'database-icon',
            questions: [
                { text: 'Show me piping class 12PD04 specifications' },
                { text: 'What are valve classes for 600# service?' },
                { text: 'Material data sheets for carbon steel pipes' }
            ]
        },
        {
            title: 'General Engineering',
            icon: 'lightbulb',
            iconClass: 'engineering-icon',
            questions: [
                { text: 'Explain stress corrosion cracking' },
                { text: 'Difference between ASME B31.3 and B31.4' },
                { text: 'What is hydrogen induced cracking?' }
            ]
        },
        {
            title: 'RIMS Integrity',
            icon: 'verified',
            iconClass: 'rims-icon',
            questions: [
                { text: 'What damage mechanisms apply to asset C-220 at Richmond?' },
                { text: 'What is the Tmin for C-220?' },
                { text: 'What is the driver for P-111A at Richmond?' }
            ]
        }
    ];

    public onQuestionClick(questionText: string): void {
        this.questionSelected.emit(questionText);
    }
}
